module.exports = __webpack_public_path__ + "img/Linkedin.84ef0e2b.png";